import {history} from '../store/index';
import {store} from '../../NextApp';
import {generateQueryString} from '../../util/Api';

import {
  CREATE_JOB_CARD_STATUS_SUCCESS,
  FETCH_JOB_CARD_STATUS_SUCCESS,
  GET_ALL_STATUS_SUCCESS,
  GET_JOB_CARD_STATUS_SUCCESS,
  SAVE_JOB_CARD_STATUS_QUERY,
} from '../../constants/ActionTypes';

import axios from 'util/Api';
import {fetchError, fetchStart, fetchSuccess} from './Common';
import {message} from "antd";
import {downloadCSV} from "../../util/methods";
import {arrayToCSV} from "./JobCard";

export const getResourceSuccess = ({ data, count }) => {
  return {
    type: GET_JOB_CARD_STATUS_SUCCESS,
    data,
    count,
  };
};

export const saveResourceQuery = (query) => {
  return {
    type: SAVE_JOB_CARD_STATUS_QUERY,
    query,
  };
};

export const createResourceSuccess = ({ data }) => {
  return {
    type: CREATE_JOB_CARD_STATUS_SUCCESS,
    data,
  };
};

export const fetchResourceSuccess = ({ data }) => {
  return {
    type: FETCH_JOB_CARD_STATUS_SUCCESS,
    data,
  };
};

export const getAllStatusSuccess = ({data}) => {
  return {
    type: GET_ALL_STATUS_SUCCESS,
    data
  };
};


export const getResource = () => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const { jobCardStatus } = store.getState();
      const { query } = jobCardStatus;
      console.log(query);
      const response = await axios.get(`/job-card?${generateQueryString(query)}`);
      console.log(response.data);
      dispatch(fetchSuccess());
      dispatch(getResourceSuccess(response.data));
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  };
};

export const getResourceForDownload = (columns, filters, selectedColumns, name) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const { jobCardStatus } = store.getState();
      const { query } = jobCardStatus;
      const response = await axios.get(`/job-card/download?columns=${columns}&${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      const str = arrayToCSV(response.data, filters, selectedColumns, columns)
      downloadCSV(str, name);
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const createResource = (payload) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.post(`/job-card/status-update`, payload);
      dispatch(fetchSuccess());
      dispatch(createResourceSuccess({ data: response.data }));
      // history.push('/job-card/allocate');
      history.goBack();
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error));
      console.log('Error****:', error);
    }
  };
};

// export const updateResource = (payload, id, urlBackToJobCard) => {
//   return async (dispatch) => {
//     dispatch(fetchStart());
//     try {
//       await axios.put(`/job-card/status-update?id=${id}`, payload);
//       if (urlBackToJobCard){
//         history.push(urlBackToJobCard);
//       } else {
//         dispatch(fetchSuccess());
//         history.push('/job-card-status');
//         dispatch(getResource());
//       }
//     } catch (error) {
//       console.log('Error****:', error);
//       dispatch(fetchError(error.response.data.message));
//     }
//   };
// };

export const updateResource = (payload, id, urlBackToJobCard) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      await axios.put(`/job-card/status-update-review-Date?id=${id}`, payload);
      dispatch(fetchSuccess());
      // dispatch(getResource());
      history.goBack();

      // if (urlBackToJobCard){
      //   // history.push(urlBackToJobCard);
      //   history.goBack();
      // } else {
      //   dispatch(fetchSuccess());
      //   // history.push('/job-card-status');
      //   // dispatch(getResource());
      //   history.goBack();
      // }
    } catch (error) {
      console.log('Error****:', error);
      dispatch(fetchError(error.response.data.message));
    }
  };
};

export const getAllStatus = () => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.get(`/status/all`);
      dispatch(fetchSuccess());
      dispatch(getAllStatusSuccess(response));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};


export const fetchResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.get(`/job-card/${id}`);
      dispatch(fetchSuccess());
      dispatch(fetchResourceSuccess({ data: response.data }));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  };
};

export const deleteResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      await axios.delete(`/job-card/allocate/${id}`);
      dispatch(fetchSuccess());
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  };
};
